<template>
  <v-chip class="pa-0"
          :style="{
            opacity: (loading)?0.5:1,
            height: small?'20px':'28px',
          }"
          @click="onChange"
  >
    <v-avatar>
      <v-icon :small="small">{{icon}}</v-icon>
    </v-avatar>
    <v-avatar
      color="yellow"
      v-if="isOk==1"
    >
      <v-icon :small="small">mdi-hand-okay</v-icon>
    </v-avatar>
    <v-avatar
      color="red"
      v-else>
      <v-icon
        color="white"
        :small="small"
      >mdi-help
      </v-icon>
    </v-avatar>
  </v-chip>
</template>

<script>
export default {
  name: 'IsOk',
  props: {
    isOk: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'mdi-account',
    },
    updateRequest: {
      type: Function,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onChange() {
      if (!this.loading) {
        this.updateValue(1 - this.isOk);
      }
    },
    updateValue(value) {
      this.$emit('updated', value);
      if (this.updateRequest) {
        this.loading = true;
        setTimeout(() => {
          this.updateRequest(value)
            .catch((error) => {
              this.$emit('updated', 1 - value);
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }, 0);
      }
    },
  },
};
</script>

<style scoped>

</style>
